import { render, staticRenderFns } from "./ArtistDialog.vue?vue&type=template&id=455ed57b"
import script from "./ArtistDialog.vue?vue&type=script&lang=js"
export * from "./ArtistDialog.vue?vue&type=script&lang=js"
import style0 from "./ArtistDialog.vue?vue&type=style&index=0&id=455ed57b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports